/**
 * 状态对象
 */
export default {
	// accessToken: '', // 认证token
	// refreshToken: '', // 刷新token
	userName: '',  // 用户信息
  }


// WEBPACK FOOTER //
// ./src/store/state.js